import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CompressionService } from '../compression.service';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-letter-decompression',
  templateUrl: './letter-decompression.component.html',
  styleUrls: ['./letter-decompression.component.css']
})
export class LetterDecompressionComponent extends GeneralExerciseComponent {

  text: string;
  decompressedText: string;
  modus: string;
  mapping: string[][];

  errors: number[] = [];
  solution: string;

  toHighlight: number;
  caretPosition: number;

  nodes: any[];
  edges: any[];

  view: any[] = undefined;
  fitContainer: boolean = true;
  curve = shape.curveBundle;

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected compressionService: CompressionService) {
    super(activatedRoute, topicService, messageService)
  }

  setTypeSpecificsFromConfiguration() {
    this.text = this.configuration.typespecifics.text;
    this.modus = this.configuration.typespecifics.modus;
    this.mapping = this.configuration.typespecifics.mapping;

    this.decompressedText = "";

    let graph = this.compressionService.computeTree(this.mapping);
    this.nodes = graph.nodes;
    this.edges = graph.edges;

    this.printable = true;

  }

  setTypeSpecificsFromState() {
    if (this.state.typespecific) {
      if (this.state.typespecific.decompressedText) {
        this.decompressedText = this.state.typespecific.decompressedText;
      }
    }
  }

  computeState() {
    this.state.typespecific.decompressedText = this.decompressedText;
  }

  checkSolution() {
    this.solution = this.text;
    let studentSolution = this.compressionService.compressLetter(this.decompressedText, this.mapping);
    this.errors = this.solution.split("").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]);

    if (this.errors.length > 0) {
      this.messageService.addAlertWithTimeout(this.get("wrongAnswer"), "danger", 10000);
    } else {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    }
  }

  evaluate(): number[] {
    this.solution = this.text;
    //check decompressable
    let decompressed = this.compressionService.decompressLetter(this.text, this.mapping);
    if (decompressed == "") {
      if (this.solved) {
        return [1, 1];
      } else {
        return [0, 1];
      }
    }
    let studentSolution = this.compressionService.compressLetter(this.decompressedText, this.mapping);
    let errors = this.solution.split("").map((v, i) => [v, i]).filter(v => v[0] != studentSolution[v[1]]).map(v => +v[1]);
    return [(this.solution.length - errors.length) / 5, this.solution.length / 5];
  }

  /** compute which text parts to highlight */
  setCaret(oField) {
    if (oField.selectionStart || oField.selectionStart == '0') {
      this.caretPosition = oField.selectionStart;
    }
    this.toHighlight = this.compressionService.compressLetter(this.decompressedText.toUpperCase().slice(0, this.caretPosition), this.mapping).length;
  }

  /** is given word errorneous? */
  inError(i: number) {
    return this.errors.includes(i);
  }

  /** remove all chars not present in the mapping */
  normalizeText() {
    let allowed = this.mapping.map(v => v[0]);
    this.decompressedText = this.decompressedText.replace(new RegExp("[^" + allowed + "]", 'gi'), '').replace(/\s+/gi, ' ').toUpperCase();
  }

  /** check if the text is no decompressable */
  notDecompressable() {
    let solution = this.compressionService.decompressLetter(this.text, this.mapping);
    if (solution == "") {
      this.messageService.addAlertWithTimeout(this.get("correct"), "success", 10000);
      this.solved = true;
      this.state.solved = true;
      this.saveState();
    } else {
      this.messageService.addAlertWithTimeout(this.get("isDecompressable"), "danger", 10000);
    }
  }



}
